import {ERROR_CODES} from "./errorCodes";
import MadmaxMessage from "../ui/messages/MadmaxMessage";
import {MESSAGE_EVENTS, MESSAGE_TYPES} from "./errorMessages";
import { CONFIG_PARAMS } from "../system/SystemConfig";

export function getCustomError(res = null, dom, config) {
    for (let msg of res.data.popup_messages) {
        let text = msg.text;
        let buttons = {};
        let code
        let type;
        let lang = 'cs'

        if (msg.buttons && Array.isArray(msg.buttons) && msg.buttons.length > 0) {
            const isWarning = msg.buttons.find(b=> b?.action === 'continue');
            buttons = msg.buttons.reduce((acc, button) => {
                let event;
                switch(button.action.toLowerCase()) {
                    case 'void':
                        event = MESSAGE_EVENTS.MESSAGE_CLOSE_GAME;
                        break;
                    case 'continue':
                        event = MESSAGE_EVENTS.MESSAGE_CLOSE;
                        break;
                    case 'history':
                        event = MESSAGE_EVENTS.OPEN_HISTORY;
                        break;
                    default:
                        event = button.action;
                }
                
                acc[button.text] = {
                    event: event
                };
                return acc;
            }, {});
            lang = config.get(CONFIG_PARAMS.LANGUAGE)
            code = ERROR_CODES.ERROR_BUTTONS;
            type = isWarning ? MESSAGE_TYPES.WARNING : MESSAGE_TYPES.ERROR;
        } else if (msg.level === "critical") {
            buttons = { "Close": {event: MESSAGE_EVENTS.MESSAGE_CLOSE_GAME} };
            code = ERROR_CODES.PLAYTECH_ERROR_CRITICAL;
            type = MESSAGE_TYPES.ERROR;
        } else {
            buttons = { "Close": {event: MESSAGE_EVENTS.MESSAGE_CLOSE} };
            code = ERROR_CODES.PLAYTECH_ERROR;
            type = MESSAGE_TYPES.WARNING;
        }

        let madmaxMessage = new MadmaxMessage("", text, buttons, lang, type, 100, config, code);

        madmaxMessage.create();
        dom.uiMessages.addMessage(madmaxMessage);
        madmaxMessage.openMessage();
    }
}